var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "private") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.44,0A61.46,61.46,0,1,1,18,18,61.21,61.21,0,0,1,61.44,0ZM74.7,53.72V50.46a14.29,14.29,0,0,0-3.93-9.9,12.75,12.75,0,0,0-18.66,0,14.25,14.25,0,0,0-3.93,9.9v3.26H74.7Zm-32.45,0V50.46a20.24,20.24,0,0,1,5.6-14,18.64,18.64,0,0,1,27.18,0,20.24,20.24,0,0,1,5.6,14v3.26h1.05a3.14,3.14,0,0,1,3.14,3.13V87.8a3.15,3.15,0,0,1-3.14,3.14H41.2a3.14,3.14,0,0,1-3.13-3.14V56.85a3.13,3.13,0,0,1,3.13-3.13h1ZM59,73.73,55.7,82.27H67.18l-3-8.65a6,6,0,1,0-5.2.11Zm39.17-49a51.89,51.89,0,1,0,15.19,36.68A51.72,51.72,0,0,0,98.13,24.76Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/Password_Icon.45af50e6af8ef2033681fa15048a58e6.svg";
export { ForwardRef as ReactComponent };